import { types, successAction, requestAction } from "@authzsvc/api-lib";

const initialState = {
  toApprove: [],
  my: [],
  fetchingOwner: false,
  activeOwner: {},
  loading: false,
};

const requests = (state = initialState, action) => {
  switch (action.type) {
    case successAction(types.GET_REQUESTS):
      return {
        ...state,
        my: action.payload.data,
        loading: false,
      };
    case successAction(types.GET_REQUESTS_TO_APPROVE):
      return {
        ...state,
        toApprove: action.payload.data,
        loading: false,
      };
    case requestAction(types.GET_REQUESTS):
    case requestAction(types.GET_REQUESTS_TO_APPROVE):
      return { ...state, loading: true };
    default:
      return state;
  }
};

export default requests;
